module.exports = __webpack_public_path__ + "static/media/2040316000.d4023ed6.jpg";